/** @jsx isolateComponent */
import { Styles } from './Styles';
import { isolateComponent } from '@zapier/style-encapsulation';

export const SymbolSize30 = () => {
  return (
    <svg
      css={Styles.root}
      width="30"
      height="30"
      data-testid="ZapierLogoSymbolSmall"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="#FF4F00" />
    </svg>
  );
};
